import { Component, EventEmitter, Input, numberAttribute, Output } from '@angular/core';
import { timer, map, Observable, finalize, takeWhile } from 'rxjs';
import { intervalToDuration } from 'date-fns/intervalToDuration';
import type { Duration } from 'date-fns/types';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html'
})
export class CountdownComponent {
  @Input({ required: true }) endDate!: Date;
  @Input({ transform: numberAttribute }) delay: number = 1000 * 60;

  @Output() finished = new EventEmitter<void>();
  @Output() updated = new EventEmitter<void>();

  private interval$: Observable<number> = timer(0, this.delay).pipe(
    map(() => Date.now()),
    takeWhile((now) => this.endDate.getTime() > now)
  );
  protected timer$: Observable<Duration> = this.interval$.pipe(
    map((now) => {
      this.updated.emit();
      return intervalToDuration({ start: now, end: this.endDate });
    }),
    finalize(() => {
      this.updated.emit();
      this.finished.emit();
    })
  );
}
